(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/shared-components/button-row/button-row-submit.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/shared-components/button-row/button-row-submit.js');
"use strict";


const Button = svs.ui.ReactButton;
const FormContext = svs.ui.reactForm.FormContext;
const ButtonRowSubmit = _ref => {
  let label = _ref.label,
    disabled = _ref.disabled;
  return React.createElement(FormContext.Consumer, null, _ref2 => {
    let form = _ref2.form;
    return React.createElement("div", {
      className: "button-row-flex"
    }, React.createElement("div", {
      className: "button-row-button-center"
    }, React.createElement(Button, {
      className: "button-width-150",
      disabled: _.values(form).some(_ref3 => {
        let isValid = _ref3.isValid;
        return !isValid;
      }) || disabled,
      focus: true,
      key: "submit-button",
      size: 300,
      type: "submit"
    }, label)));
  });
};
svs.ticket_partner.sharedComponents.buttonRow.ButtonRowSubmit = ButtonRowSubmit;

 })(window);